import { render } from "./nhlTeamDraftColumn.vue?vue&type=template&id=59b008df"
import script from "./nhlTeamDraftColumn.vue?vue&type=script&lang=js"
export * from "./nhlTeamDraftColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__